/***
 * @file:tabæ ç­¾é¡µé¢
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { findIndex, isEmpty } from 'lodash';

import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { UrlChangeService } from '@ithinkdt/shared/route';
import { COMMON_COMFIG } from '@ithinkdt/shared/utils';
import { PageData, Pages, ThemeConfig } from '@ithinkdt/theme/models';
import { CloseTabUrl, PageTabService } from '@ithinkdt/theme/page-tab-service';

@Component({
  selector: 'dt-pages-tab',
  templateUrl: './pages-tab.component.html',
  styleUrls: ['./pages-tab.component.scss'],
})
export class PagesTabComponent {
  /** æå¼çé¡µé¢æ°æ®å­å¨ */
  @Input() pages: Pages;
  /** æ¶èçé¡µé¢ */
  @Input() collection: PageData[];
  /** æ¯å¦æå  */
  @Input() collapsed: boolean;
  /** æ¯å¦ä¸ºé¡¶é¨èå */
  @Input() topMenu: boolean;
  /** æ¯å¦åºå®æ¶èæé® */
  @Input() fixHeader: boolean;
  /** åå®¹åºåå®½åº¦ */
  @Input() fixWidth: boolean;
  /** æ¯å¦åºè¯¥éètab */
  @Input() shouldHide: boolean;
  /** tabåæ¢åè° */
  @Output() sendTabChanges: EventEmitter<any> = new EventEmitter();
  /** æ¶èåååè° */
  @Output() sendColChanges: EventEmitter<any> = new EventEmitter();

  findIndexFunc = findIndex;
  themeConfig: ThemeConfig;

  constructor(
    private router: Router,
    private urlChangeSrv: UrlChangeService,
    private pageTabSrv: PageTabService,
    private settingsSrv: SettingsService,
    private i18nSrv: I18NService
  ) {
    this.themeConfig = this.settingsSrv.userConfig['theme'] || {};
    this.addTabChangeSub();
  }

  addTabChangeSub() {
    this.pageTabSrv.tabChange$.subscribe((url: CloseTabUrl) => {
      const closedUrl = url.closedUrl || this.curRouter;
      const closedTab = this.pages.data.filter((d) => d.pureRouter === closedUrl)[0];
      const redirectTab = this.getRedirectTab(url.redirectUrl);
      this.closeTab(closedTab, redirectTab);
    });
  }

  getRedirectTab(redirectUrl?: string): PageData {
    if (!redirectUrl) {
      return;
    }

    // TODO: redirectUrlçé¡µé¢æ²¡æå¼ï¼åè¯»ååå®¹
    const redirectTab = this.pages.data.filter((d) => d.pureRouter === redirectUrl)[0] || {
      url: redirectUrl,
      pureRouter: redirectUrl,
    };
    return redirectTab;
  }

  /**
   * @param closedTab è¦å³é­çtab
   * @param redirectTab è¦æå¼çtab
   * @desc å³é­tab
   */
  closeTab(closedTab: PageData, redirectTab?: PageData): void {
    if (isEmpty(closedTab)) {
      console.warn(this.i18nSrv.interpret('default.route.error'));
      return;
    }

    const openedTabTotal = this.pages.data.length; // æå¼çtabæ°é
    // å©ä½ä¸ä¸ªä¸ç»å³é­
    if (openedTabTotal === 1) {
      return;
    }

    // å é¤è¦å³é­çtabæ°æ®
    const willCloseIdx = this.getIdxInTab(closedTab); // è¦å³é­çtabå¨æææå¼tabä¸­çç´¢å¼
    const activeInx = this.pages.index; // ä¸æ¬¡éä¸­çtabç´¢å¼
    this.deleteTabData(willCloseIdx, closedTab.pureRouter);

    // å¦ææéå®åurlï¼åå³é­å½åé¡µé¢ï¼åè°éå®åurléé¢çæ¹æ³
    isEmpty(redirectTab)
      ? this.normalClose(willCloseIdx, activeInx, openedTabTotal)
      : this.closeAndCallback(redirectTab);
  }

  deleteTabData(willCloseIdx, pureRouter) {
    this.pages.data.splice(willCloseIdx, 1);
    this.sendTabChanges.emit(this.pages);
  }

  // å³é­tabå¹¶åè°è¦æå¼tabå¯¹åºç»ä»¶çå½æ°
  closeAndCallback(redirectTab: PageData) {
    // tslint:disable-next-line:prefer-const
    let { url, pureRouter } = redirectTab;
    pureRouter = pureRouter.substr(1).replace('/', '_');
    const routeCacheMap: any = (window as any).dtRouteCache || new Map();
    const routeCache = routeCacheMap.get(pureRouter);
    const ret = !!(routeCache && routeCache.handle);

    if (ret && routeCache.handle.componentRef) {
      this.runHook('_onReuseCb', routeCache.handle.componentRef);
    }
    this.calcWillActiveTabIdx(redirectTab);
    this.router.navigateByUrl(url);
  }

  private runHook(method: string, comp: any) {
    if (comp.instance && typeof comp.instance[method] === 'function') {
      comp.instance[method]();
    }
  }

  // è®¡ç®æå¼é¡µé¢çä¸æ : å·²å­å¨çæèä¸å­å¨æ°æå¼ç
  private calcWillActiveTabIdx(redirectTab: PageData) {
    const idx = findIndex(this.pages.data, redirectTab); // è¦å³é­çtabå¨æææå¼tabä¸­çç´¢å¼
    this.pages.index = idx || this.pages.data.length;
  }

  /**
   * @param willCloseIdx å°è¦å³é­çtabçindex
   * @param activeInx å½åæ¿æ´»çindex
   * @param openedTabTotal æå¼çtabæ°
   * @desc å³é­tabæ¶çæåµ
   * 1. å°è¦å³é­çtabå¨å½åæå¼çtabä¹åï¼ willCloseIdx < activeInx, åªéè¦æ´æ°ç°å¨æ¿æ´»çtab indexï¼å³ this.pages.index--ï¼ æ éè·³è½¬
   * 2. å°è¦å³é­çtabå°±æ¯å½åæå¼çtabï¼
   *    2.1. è¥æ­¤tabåé¢æ tabï¼å³è¦å³é­çtabæ¯æåä¸ä¸ª(willCloseIdx === openedTabTotal - 1)ï¼ åæå¼åé¢çä¸ä¸ªtabï¼ å° this.pages.index-1ï¼ å³æ¿æ´»çtab index å°äº1
   *    2.2  è¥æ­¤tabåé¢è¿ætabï¼ åæå¼åé¢çç¬¬ä¸ä¸ªtabï¼æ¿æ´»tabçindexä¸å
   * 3. å°è¦å³é­çtabå¨å½åæå¼çtabä¹åï¼ä¸éè¦æä½ï¼ä¸éè¦è·³è½¬ï¼ ä¸éè¦æ´æ°æ¿æ´»çtab index
   */
  normalClose(willCloseIdx, activeInx, openedTabTotal) {
    // STEP1 å ä¸ºæ°ç»éé¢å°äºä¸ä¸ªï¼æä»¥éä¸­çindex-1
    if (willCloseIdx < activeInx) {
      this.pages.index--;
    }

    // STEP2 å¦æå³é­çæ¯å½åé¡µé¢ï¼åè·³è½¬è·¯ç±
    if (willCloseIdx === activeInx) {
      // å¦ææ¯æåä¸ä¸ªï¼åæå¼åé¢çï¼å¦åæå¼åé¢çï¼æå¼åé¢çå½åæ¾ç¤ºçidxä¸åï¼
      if (willCloseIdx >= openedTabTotal - 1) {
        // å ä¸ºæ°ç»éé¢å°äºä¸ä¸ªï¼æä»¥éä¸­çindex-1
        this.pages.index--;
      }
      const { index, data } = this.pages;
      this.router.navigateByUrl(data[index].url);
    }
  }

  // è·åå½åçæ°æ®å¨tabæ°ç»ä¸­çindex
  getIdxInTab(pageData: PageData) {
    return findIndex(this.pages.data, pageData);
  }

  openTab(url) {
    this.router.navigateByUrl(url);
  }

  /** å é¤æ¶è */
  deleteCollect(data: PageData) {
    const index = findIndex(this.collection, data);
    this.collection.splice(index, 1);
    this.sendColChanges.emit(this.collection);
  }

  /** æ¶è&åæ¶æ¶è */
  changeStatus(data: PageData) {
    const index = findIndex(this.collection, data);
    index > -1 ? this.collection.splice(index, 1) : this.collection.push(data);
    this.sendColChanges.emit(this.collection);
  }

  //  è®¡ç®æ¯å¦æ¾ç¤ºå³é­æé®
  isHomePage(url) {
    // è¥æ¯æ²¡éç½®é¡¹ç®é¦é¡µï¼åä½¿ç¨æ¡æ¶é»è®¤çé¦é¡µéç½®é¡¹
    if (isEmpty(this.themeConfig.homePages)) {
      return url === COMMON_COMFIG.HOME_URL;
    }

    return this.themeConfig.homePages.indexOf(url) > -1 ? true : false;
  }

  get curRouter(): string {
    return this.urlChangeSrv.getCurrentRouter();
  }
}
